import firebase from 'firebase/app';
import 'firebase/database';

const firebaseConfig = {
    apiKey: "AIzaSyBdH98rlExi0hmINhkK_Mt3_azfdWcaKXs",
    authDomain: "thegioibep-5cd8e.firebaseapp.com",
    databaseURL: "https://thegioibep-5cd8e-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "thegioibep-5cd8e",
    storageBucket: "thegioibep-5cd8e.firebasestorage.app",
    messagingSenderId: "733846571423",
    appId: "1:733846571423:web:f37d90bc98dba82a7d15aa",
    measurementId: "G-1JMRKD3F4G"
};
const firebaseApp = firebase.initializeApp(firebaseConfig);
export const db = firebaseApp.database();